/**
 * @description 获取页面所在路径
 * @returns {string}
 */
export const addressBarFilePath = (): string => location.pathname
